import React from "react";

import { loadModules } from "@esri/react-arcgis";
const options = { url: "https://js.arcgis.com/3.28/" };
const app = {};

class MapComponent extends React.Component {
  renderMap() {
    return;
  }
  componentDidMount() {
    loadModules(
      [
        "esri",
        "esri/map",
        "esri/graphic",
        "esri/tasks/query",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/layers/FeatureLayer",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/SimpleLineSymbol",
        "esri/renderers/SimpleRenderer",
        "esri/Color",
        "esri/geometry/webMercatorUtils",
        "esri/dijit/PopupTemplate",
        "esri/layers/WMSLayer",
        "esri/layers/WMSLayerInfo",
        "esri/layers/DynamicLayerInfo",
        "esri/geometry/Extent",
        "esri/layers/KMLLayer",
        "esri/dijit/Legend",
      ],
      options
    ).then(
      ([
        esri,
        Map,
        Graphic,
        Query,
        DynamicLayer,
        FeatureLayer,
        SimpleFillSymbol,
        SimpleLineSymbol,
        SimpleRenderer,
        Color,
        webMercatorUtils,
        PopupTemplate,
        WMSLayer,
        WMSLayerInfo,
        DynamicLayerInfo,
        Extent,
        KMLLayer,
        Legend
      ]) => {
        app.Query = Query;
        app.webMercatorUtils = webMercatorUtils;
        app.layer_config = esri.layers.FeatureLayer.SELECTION_NEW;
        app.FeatureLayer = FeatureLayer;
        app.layer_config_auto = FeatureLayer.MODE_AUTO;
        app.PopupTemplate = PopupTemplate;
        app.Graphic = Graphic;
        app.PopupTemplate = PopupTemplate;
        app.WMSLayer = WMSLayer;
        app.WMSLayerInfo = WMSLayerInfo;
        app.DynamicLayer = DynamicLayer;
        app.DynamicLayerInfo = DynamicLayerInfo;
        app.Extent = Extent;
        app.KMLLayer = KMLLayer;
        app.Legend=Legend;
        var highlightSymbol = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([189, 191, 192]),
            1.2
          ),
          new Color([125, 125, 125, 0.25])
        );
        var symbol = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([121, "085", "061", 0.25]),
            1
          ),
          new Color([125, 125, 125, 0])
        );
        var sfs = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([52, 148, 232]),
            2
          ),
          new Color([52, 148, 232, 0.25])
        );
        app.highlightSymbol = highlightSymbol;
        app.map = new Map("viewDiv", {
          basemap: "streets",
          minZoom: 3,
          maxZoom: 19,
          center: [-75.074387, -10.39665],
          zoom: 6,
          showLabels: true
        });
        app.map.on("load", function () {
          app.load = true;
          app.capaBase = new DynamicLayer(
            "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer",
            {
              id: "red",
              opacity: 0.2,
              showAttribution: false
            }
          );
          app.map.addLayer(app.capaBase);
          app.capaDpto = new FeatureLayer(
            "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer/0",
            {
              id: "Dpto",
              mode: FeatureLayer.MODE_AUTO,
              showAttribution: false,
              outFields: ["*"]
            }
          );
          app.capaDpto.setRenderer(new SimpleRenderer(symbol));
          app.capaDpto.setSelectionSymbol(sfs);
          app.map.addLayer(app.capaDpto);
          app.load = true;
        });
      }
    );
  }
  addLayerKml(layer, record) {
    let layerData = new app.KMLLayer(record.url);
    app[layer] = layerData;
    app.map.addLayer(app[layer]);
  }
  addLayerWms(layer, record) {
    let layerData = new app.WMSLayer(record.url, {
      id: layer,
      resourceInfo: {
        extent: new app.Extent(0, 0, 0, 0, {
          wkid: 4326
        }),
        layerInfos: [
          new app.WMSLayerInfo({
            name: record.layerName,
            title: "Capa",
            showPopup: true
          })
        ],
        format: "png",
        version: "1.1.1",
        bgcolor: "ffffff"
      },
      visibleLayers: [record.layerName]
    });
    app[layer] = layerData;
    app.map.addLayer(app[layer]);
  }
  addLayerWfs(layer, record) {
    let template = new app.PopupTemplate({
      title: record.label,
      fieldInfos: [{ fieldName: "*", visible: true }]
    });
    let layerData = new app.FeatureLayer(record.url, {
      id: layer,
      layerId: layer,
      name: layer,
      infoTemplate: template,
      mode: app.layer_config_auto,
      showAttribution: true,
      outFields: ['*']
    });
    app[layer] = layerData;
    app.map.addLayer(app[layer]);
    if (this.props.legendName &&
      document.getElementById(this.props.legendName).childElementCount == 0) {
      app.legend = new app.Legend({
        map: app.map,
        layerInfos: [{
          layer: layerData,
          title: record.label
        }]
      }, this.props.legendName);
      app.legend.startup();
    } else {
      app.legend.layerInfos.push({
        layer: layerData,
        title: record.label
      });
      app.legend.layers.push(layerData);
      app.legend.refresh();
    }
  }
  render() {
    let me = this;
    if (app.load) {
      if (this.props.dataLayer.length > 0) {
        this.props.dataLayer.forEach(function (record) {
          let layer = record.id;
          if (!record.init) {
            if (record.type === "wms") {
              me.addLayerWms(layer, record);
            } else if (record.type === "wfs") {
              me.addLayerWfs(layer, record);
            } else {
              me.addLayerKml(layer, record);
            }
          } else {
            if (record.type === "wms") {
              if (!record.checked) {
                if (app[layer]) {
                  app[layer].hide();
                }
              } else {
                if (!app[layer]) {
                  me.addLayerWms(layer, record);
                } else {
                  app[layer].show();
                }
              }
            } else if (record.type === "wfs") {
              if (!record.checked) {
                if (app[layer]) {
                  app[layer].hide();
                }
              } else {
                if (!app[layer]) {
                  me.addLayerWfs(layer, record);
                } else {
                  app[layer].show();
                }
              }
            } else {
              if (record.type === "kml") {
                if (!record.checked) {
                  if (app[layer]) {
                    app[layer].hide();
                  }
                } else {
                  if (!app[layer]) {
                    me.addLayerKml(layer, record);
                  } else {
                    app[layer].show();
                  }
                }
              }
            }
          }
        });
      } else {
        if (app.map.layerIds.length > 0) {
          app.map.layerIds.forEach(item => {
            if (item !== "layer0" && item !== "red") {
              if (app[item]) {
                app[item].hide();
              }
            }
          });
        }
      }
    }
    if (app.load && this.props.ubigeo) {
      const value = this.props.ubigeo;
      var query = new app.Query();
      query.returnGeometry = true;
      if (value === "00") {
        app.capaDpto.clearSelection();
        app.map.centerAndZoom([-75.074387, -10.39665], 5);
      } else {
        query.where = "IDDPTO=" + value;
        app.capaDpto.selectFeatures(query, app.layer_config, function (
          features
        ) {
          if (features[0]) {
            app.map.setExtent(features[0].geometry.getExtent().expand(1.5));
          }
        });
      }
    }
    return <div>{this.renderMap()}</div>;
  }
}
export default MapComponent;
